/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PersonType } from './person-type';
import {
    PersonTypeFromJSON,
    PersonTypeFromJSONTyped,
    PersonTypeToJSON,
    PersonTypeToJSONTyped,
} from './person-type';

/**
 * 
 * @export
 * @interface PersonInfoDto
 */
export interface PersonInfoDto {
    /**
     * 
     * @type {PersonType}
     * @memberof PersonInfoDto
     */
    type: PersonType;
    /**
     * 
     * @type {string}
     * @memberof PersonInfoDto
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof PersonInfoDto
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof PersonInfoDto
     */
    middleName: string;
    /**
     * 
     * @type {string}
     * @memberof PersonInfoDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonInfoDto
     */
    phone?: string | null;
}



/**
 * Check if a given object implements the PersonInfoDto interface.
 */
export function instanceOfPersonInfoDto(value: object): value is PersonInfoDto {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('middleName' in value) || value['middleName'] === undefined) return false;
    return true;
}

export function PersonInfoDtoFromJSON(json: any): PersonInfoDto {
    return PersonInfoDtoFromJSONTyped(json, false);
}

export function PersonInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': PersonTypeFromJSON(json['type']),
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'middleName': json['middleName'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
    };
}

  export function PersonInfoDtoToJSON(json: any): PersonInfoDto {
      return PersonInfoDtoToJSONTyped(json, false);
  }

  export function PersonInfoDtoToJSONTyped(value?: PersonInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': PersonTypeToJSON(value['type']),
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'middleName': value['middleName'],
        'email': value['email'],
        'phone': value['phone'],
    };
}

